import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { ConsoleShell } from '@/features/shell/console-shell';
import { ProjectResolver } from '@/features/shell/project-resolver';

/**
 * `/$tenant/workflows` — entrée hors projet : redirige vers `/$tenant/projects/$projectId/workflows`.
 * Elle rend routée l'entrée « Workflows » de la navigation, inerte jusqu'ici faute de projet.
 */
export const Route = createFileRoute('/$tenant/workflows/')({ component: WorkflowsRoute });

function WorkflowsRoute() {
  const { tenant } = Route.useParams();
  const { t } = useTranslation();
  return (
    <ConsoleShell tenantId={tenant} activeItem="workflows" crumbs={[{ label: t('nav.items.workflows') }]}>
      <ProjectResolver tenantId={tenant} section="workflows" />
    </ConsoleShell>
  );
}
